/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import { courrierTypeSchema } from "./courrierTypeSchema.ts";
import { documentTypeSchema } from "./documentTypeSchema.ts";
import { z } from "zod";

export const propertyDocumentSchema = z.object({
      "title": z.string().optional(),
  "ref": z.string().optional(),
  "documentType": z.lazy(() => documentTypeSchema).describe("Type de document :\n- IMAGE : Image JPG, PNG...\n- DOCUMENT : Document PDF, DOC...\n").optional(),
  "courrierType": z.lazy(() => courrierTypeSchema).describe("Type de courrier :\n- MANDATE : Mandat\n- AGREEMENT : Compromis\n- DEED : Acte\n- DIAGNOSTIC : Diagnostic\n- INVENTORY : Etat des lieux\n- OTHER : Autre\n").optional(),
  "url": z.string().optional(),
  "extension": z.string().optional(),
  "isPrivate": z.boolean().optional(),
  "order": z.number().int().optional(),
  "group": z.string().optional()
      })